module.exports = __webpack_public_path__ + "img/cart.1bb59a64.svg";